module.exports = __webpack_public_path__ + "img/economic.2aefcc54.png";